import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import DealingIn from '../components/DealingIn';
import Authorities from '../components/Authorities';
import WhyChooseUs from '../components/WhyChooseUs';
import FAQ from '../components/FAQ';

const Home = () => {
  return (
    <div>
      <Hero />
      <About />
      <DealingIn />
      <Authorities />
      <WhyChooseUs />
      <FAQ />
    </div>
  );
};

export default Home;